import React from 'react';
import { Input } from 'reactstrap';
import { connect } from 'react-redux';
import { VMAIL_ROUTE } from '../../lib/constants';
import TooltipIcon from '../EpikBoxes/EpikBoxDetails/TooltipIcon/TooltipIcon';
import alertErrorMessageWarning from '../../Res/Icon/alertErrorMessageWarning.svg';

const T37_INTELIQUENT_TRUNK = 'LSANCARCGR6_3590';
const T37_VOICETEL_GATEWAY = '208.65.249.113:5080';

const isInvalidEfaxRoute = (number) => {
  if (!number) return false;

  const notOnDevice = !number.linkedBox;
  if (number.type !== 'fax' || !number.onlyEfax || !notOnDevice) {
    return false;
  }

  if (number.carrier === 'inteliquent') {
    return number.trunk !== T37_INTELIQUENT_TRUNK;
  }

  if (number.carrier === 'voicetel') {
    return number?.routeInfo?.gateway !== T37_VOICETEL_GATEWAY;
  }

  return false;
};

const NumberRoute = ({ onChange, gateways, number, vmail, trunks, tdmRoutes, disabled }) => {
  const toSelectGateway = vmail ? VMAIL_ROUTE.gateway : number?.routeInfo?.gateway;
  let routeArr = gateways;
  const showEfaxRouteWarning = isInvalidEfaxRoute(number);
  const tipId = `efax-route-warning-${number?._id || 'route'}`;

  if (number.carrier === 'inteliquent') routeArr = trunks.trunkGroupList;

  return (
   <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
   <Input type="select" onChange={e => onChange(e)} disabled={vmail || disabled} style={{ flex: 1 }}>
      {number.carrier === 'tdm' &&
        tdmRoutes?.map(route => (
          <option
            key={route.value}
            data-trunk={`${route.value}`}
            selected={tdmRoutes.some(el => el.value === route.value)}
          >
            {route.label}
          </option>
        ))}

      {number.carrier !== 'tdm' &&
        routeArr?.map(el => {
          return (
            <>
              {number.carrier === 'inteliquent' ? (
                <>
                  <option
                    key={el.trunkGroupName}
                    data-trunk={`${el.trunkGroupName}`}
                    value={JSON.stringify(el)}
                    selected={number.trunk === el.trunkGroupName}
                  >
                    {el.trunkGroupName}
                  </option>
                </>
              ) : (
                <option
                  key={el.route}
                  value={JSON.stringify(el)}
                  selected={el.gateway === toSelectGateway}
                  data-trunks={el.gateway}
                >
                  {el.gateway === '208.65.249.104:5080' ? 'unified.epik.io' : el.gateway}
                </option>
              )}
            </>
          );
        })}
    </Input>
      {showEfaxRouteWarning ? (
        <TooltipIcon
          tipId={tipId}
          imgSrc={alertErrorMessageWarning}
          displayData="route is not valid efax route."
          placement="top"
          customStyle={{
            width: '18px',
            height: '18px',
            minHeight: '18px',
            objectFit: 'contain',
          }}
        />
      ) : null}
    </div>
  );
};
const mapStateToProps = state => ({
  gateways: state.AppState.provisioning.gateways,
  trunks: state.AppState.provisioning.trunkGroupList,
  tdmRoutes: state.AppState.tdmRoutes,
});

export default connect(
  mapStateToProps,
  null,
)(NumberRoute);
